"use strict";
/*
 * Created on 09.05.2019
 */

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PromoSettingsValidatorSets_1 = require("../PromoSettingsValidatorSets");
/**
 * Default window type settings model
 * @author Tomáš Leity
 */


var DefaultWindowTypeSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DefaultWindowTypeSettings, _DomainObject_1$Domai);

  /**
   * @param name
   * @param promoVolumeThresholdRel
   * @param promoVolumeThresholdAbs
   * @param promoVolumeThresholdEnabled
   * @param coordinatorApprovalNeeded
   * @param systemVolumeThresholdRel
   * @param systemVolumeThresholdAbs
   * @param systemVolumeThresholdEnabled
   */
  function DefaultWindowTypeSettings(name, promoVolumeThresholdRel, promoVolumeThresholdAbs, promoVolumeThresholdEnabled, coordinatorApprovalNeeded, systemVolumeThresholdRel, systemVolumeThresholdAbs, systemVolumeThresholdEnabled) {
    var _this;

    _classCallCheck(this, DefaultWindowTypeSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DefaultWindowTypeSettings).call(this));
    _this.name = name;
    _this.promoVolumeThresholdRel = promoVolumeThresholdRel;
    _this.promoVolumeThresholdAbs = promoVolumeThresholdAbs;
    _this.promoVolumeThresholdEnabled = promoVolumeThresholdEnabled;
    _this.coordinatorApprovalNeeded = coordinatorApprovalNeeded;
    _this.systemVolumeThresholdRel = systemVolumeThresholdRel;
    _this.systemVolumeThresholdAbs = systemVolumeThresholdAbs;
    _this.systemVolumeThresholdEnabled = systemVolumeThresholdEnabled;
    return _this;
  }

  return DefaultWindowTypeSettings;
}(DomainObject_1.DomainObject);

exports.DefaultWindowTypeSettings = DefaultWindowTypeSettings;

DefaultWindowTypeSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DefaultWindowTypeSettings.name);
  return {
    name: builder.str('name'),
    promoVolumeThresholdRel: builder.num.apply(builder, ['promoVolumeThresholdRel'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    promoVolumeThresholdAbs: builder.num.apply(builder, ['promoVolumeThresholdAbs'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    promoVolumeThresholdEnabled: builder.bool('promoVolumeThresholdEnabled'),
    coordinatorApprovalNeeded: builder.bool('coordinatorApprovalNeeded'),
    systemVolumeThresholdRel: builder.num.apply(builder, ['systemVolumeThresholdRel'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    systemVolumeThresholdAbs: builder.num.apply(builder, ['systemVolumeThresholdAbs'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    systemVolumeThresholdEnabled: builder.bool('systemVolumeThresholdEnabled')
  };
}();